export const navigateToXboxCom = () => (window.location.href = "https://www.xbox.com");
